
function IconBoxHome14({ fill, stroke }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.38892 7L7.38892 1L13.3889 7V9.5C13.3889 11.433 11.8219 13 9.88892 13H4.88892H1.38892V7Z" fill={fill} />
      <path d="M4.88892 13H1.38892V7L7.38892 1L13.3889 7V9.5C13.3889 11.433 11.8219 13 9.88892 13V13M4.88892 13V7.5H9.88892V13M4.88892 13H9.88892" stroke={stroke} />
    </svg>
  )
}

export default IconBoxHome14